<template>
    <div class="content-center none-click">
      <div class="banner">
        <div class="banner_box">
            <div class="banner_title">千橙系列产品</div>
            <div class="banner_title2">官方下载获取专区</div>
            <!-- <div class="banner_text">帮助品牌/平台企业打造全链路管理平台，整合上游资源，管理中端渠道，赋能下游零售客户，为顾客提供更好的产品和服务</div> -->
        </div>
        <img src="@/assets/Mobile/images/QcDownload/banner.png" alt="">
      </div>
      <div class="content">
        <div class="content_box">
            <div class="box_top">
                <img src="@/assets/Mobile/images/QcDownload/top1.png" alt="">
            </div>
            <div class="box_bottom">
                <div class="box_item box_item3">
                    <img class="item_img" src="@/assets/Mobile/images/QcDownload/box1.png" alt="">
                    <div class="item_title">千橙超级店长</div>
                    <div class="box_btn box_btn3">
                        <div class="item_btn item_btn1" @click="addTimeStamps(QcShopkeeperUrl)">
                            <img src="@/assets/Mobile/images/QcDownload/icon1.png" alt="">
                            <span>安卓客户端</span>
                        </div>
                        <div class="item_btn item_btn2"  @click="goApple('https://apps.apple.com/cn/app/%E6%B1%87%E4%BA%AB%E8%B4%AD%E5%95%86%E5%AE%B6%E7%89%88/id1585589549')">
                            <img src="@/assets/Mobile/images/QcDownload/icon2.png" alt="">
                            <span>苹果客户端</span>
                        </div>
                    </div>
                </div>
                <div class="box_item box_item3">
                    <img class="item_img" src="@/assets/Mobile/images/QcDownload/box2.png" alt="">
                    <div class="item_title">千橙收银</div>
                    <div class="box_btn box_btn3">
                        <div class="item_btn item_btn1"  @click="addTimeStamps(QcCashierUrl)">
                            <img src="@/assets/Mobile/images/QcDownload/icon1.png" alt="">
                            <span>安卓客户端</span>
                        </div>
                    </div>
                </div>
                <div class="box_item box_item_fruit box_item3">
                    <img class="item_img" src="@/assets/Mobile/images/QcDownload/box_fruit.png" alt="">
                    <div class="item_title">千橙收银生鲜版</div>
                    <div class="box_btn box_btn3">
                        <div class="item_btn item_btn1"  @click="addTimeStamps(QcCashierFruitUrl)">
                            <img src="@/assets/Mobile/images/QcDownload/icon1.png" alt="">
                            <span>安卓客户端</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content_box">
            <div class="box_top">
                <img src="@/assets/Mobile/images/QcDownload/top2.png" alt="">
            </div>
            <div class="box_bottom">
                <div class="box_item">
                    <img class="item_img" src="@/assets/Mobile/images/QcDownload/box3.png" alt="">
                    <div class="item_title">千橙微商城</div>
                    <div class="box_btn">
                        <div class="item_btn item_btn1" @click="addTimeStamps(QcShoppingMallUrl)">
                            <img src="@/assets/Mobile/images/QcDownload/icon1.png" alt="">
                            <span>安卓客户端</span>
                        </div>
                        <div class="item_btn item_btn2" @click="goApple('https://itunes.apple.com/cn/app/id6472264795')">
                            <img src="@/assets/Mobile/images/QcDownload/icon2.png" alt="">
                            <span>苹果客户端</span>
                        </div>
                    </div>
                </div>
                <div class="box_item">
                    <img class="item_img" src="@/assets/Mobile/images/QcDownload/box4.png" alt="">
                    <div class="item_title">汇团团</div>
                    <div class="box_btn">
                        <div class="item_btn item_btn3" @click="selectMark(1)">
                            <img src="@/assets/Mobile/images/QcDownload/icon1.png" alt="">
                            <span>扫码识别</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="content_box">
            <div class="box_top">
                <img src="@/assets/Mobile/images/QcDownload/top3.png" alt="">
            </div>
            <div class="box_bottom" style="justify-content: start;">
                <div class="box_item" style="margin-left:12px;">
                    <img class="item_img" src="@/assets/Mobile/images/QcDownload/box5.png" alt="">
                    <div class="item_title">千橙F2B2C</div>
                    <div class="box_btn">
                        <div class="item_btn item_btn1"  @click="addTimeStamps(QcCommerceUrl)">
                            <img src="@/assets/Mobile/images/QcDownload/icon1.png" alt="">
                            <span>安卓客户端</span>
                        </div>
                        <div class="item_btn item_btn2" @click="goApple('https://apps.apple.com/tt/app/%E6%A9%99%E6%84%8F%E6%8E%8C%E6%9F%9C/id1563349231')">
                            <img src="@/assets/Mobile/images/QcDownload/icon2.png" alt="">
                            <span>苹果客户端</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="content_box">
            <div class="box_top">
                <img src="@/assets/Mobile/images/QcDownload/top4.png" alt="">
            </div>
            <div class="box_bottom" style="justify-content: start;">
                <div class="box_item" style="margin-left:12px;">
                    <img class="item_img" src="@/assets/Mobile/images/QcDownload/box6.png" alt="">
                    <div class="item_title">千橙分销</div>
                    <div class="box_btn">
                        <div class="item_btn item_btn3"  @click="selectMark(2)">
                            <img src="@/assets/Mobile/images/QcDownload/icon1.png" alt="">
                            <span>扫码识别</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content_box">
            <div class="box_top">
                <img src="@/assets/Mobile/images/QcDownload/top5.png" alt="">
            </div>
            <div class="box_bottom" style="justify-content: start;">
                <div class="box_item" style="margin-left:12px;">
                    <img class="item_img" src="@/assets/Mobile/images/QcDownload/box7.png" alt="">
                    <div class="item_title">千橙数字人</div>
                    <div class="box_btn">
                        <div class="item_btn item_btn3">
                            <img src="@/assets/Mobile/images/QcDownload/icon3.png" alt="">
                            <span>内测申请</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="mark" v-if="isMark" @click.default="isMark = false">
        <div class="mark_box">
            <img class="seek_close" @click="isMark =false" src="@/assets/images/seek_close.png" alt="">
            <div class="mark_title">{{selectItem == '1'? '汇团团' :selectItem == '2'? '千橙分销':'' }}</div>
            <div class="mark_code">
                <img class="mark_code1" v-if="selectItem == '1'" src="@/assets/images/login/code4.png" alt="">
                <img class="mark_code2" v-if="selectItem == '2'" src="@/assets/images/login/code5.png" alt="">
            </div>
        </div>
      </div>
      <Case title="微商城" />
      <ContactForm info-sources="微商城" />
      <TryModal v-if="tryVisible" :visible="tryVisible" info-sources="B2B2C" @cancel="modalClose" />

    </div>
  </template>

  <script>
  import metaInfo from '@/common/util/metaInfo'
  import ContactForm from '@/Mobile/Mobilecom/ContactForm'
  import Case from '@/Mobile/Mobilecom/Case'
  import TryModal from '@/Mobile/Mobilecom/TryModal'

  export default {
    metaInfo: metaInfo.QcDownload,
    components: {
      ContactForm,
      Case,
      TryModal
    },
    data() {
      return {
        tryVisible: false,
        tooItem:'1',
        isMark:false,
        selectItem:'',
        visible: false,
        toolBg: require("@/assets/images/QcCashier/tool1.png"),
        tooItem: "1",
        QcShopkeeperUrl: '',//千橙超级店长安卓下载地址
        QcCashierUrl: '',//千橙收银安卓下载地址
        QcCashierFruitUrl: '', // 千橙收银安卓生鲜版下载地址
        QcShoppingMallUrl: '',//千橙微商城安卓下载地址
        QcCommerceUrl: '',//千橙F2B2C安卓下载地址
      }
    },
    mounted() {
        this.getQcShopkeeperUrl()
        this.getQcCashierUrl()
        this.getQcShoppingMallUrl()
        this.getQcCashierFruitUrl()
        this.getQcCommerceUrlUrl()
    },
    methods: {
        selectMark(item){
            this.selectItem = item
            this.isMark = true
        },
        getQcCommerceUrlUrl(){
            let _this = this
            var ajax = new XMLHttpRequest();
            // 使用get请求
            ajax.open("post", 'https://gateway.qcos.cn/prod/saasapi/member/storeAppVersion/getStoreAppVersion');
            ajax.setRequestHeader("Content-type", "application/json");
            // 格式type=3&bin=998字符串的格式
            var data = JSON.stringify({ 'appSource': 1,'platForm': 1 });
            ajax.send(data);
            // 注册事件
            ajax.onreadystatechange = function () {
            if (ajax.readyState == 4 && ajax.status == 200) {
                //console.log(ajax.responseText);
                var str = ajax.responseText;
                //将json字符串转换为json对象
                var obj = eval("(" + str + ")");
                _this.QcCommerceUrl= obj.data.versionUrl;
                console.log(_this.QcCommerceUrl,'QcCommerceUrl')
            }
            };
        },
        getQcShopkeeperUrl(){
            let _this = this
            var ajax = new XMLHttpRequest();
            // 使用get请求
            ajax.open("get", 'https://gateway.qcos.cn/prod/htdtapp/notAuth/bossappVersion/getBossAppVersion?appSource=1002&callback=callbackfunction&channelType=1');
            ajax.setRequestHeader("Content-type", "application/json");
            // 格式type=3&bin=998字符串的格式
            ajax.send();
            // 注册事件
            ajax.onreadystatechange = function () {
            if (ajax.readyState == 4 && ajax.status == 200) {
                //console.log(ajax.responseText);
                var str = ajax.responseText;
                //将json字符串转换为json对象
                var obj = eval("(" + str + ")");
                _this.QcShopkeeperUrl= obj.data.appUrl;
                console.log(_this.QcShopkeeperUrl,'QcShopkeeperUrl')
            }
            };
        },
        getQcCashierFruitUrl(){
            let _this = this
            var ajax = new XMLHttpRequest();
            // 使用get请求
            ajax.open("get", 'https://gateway.htd.cn/prod/htdtcashier/appVersion/getAppVersion?industryNo=1004');
            ajax.setRequestHeader("Content-type", "application/json");
            // 格式type=3&bin=998字符串的格式
            ajax.send();
            // 注册事件
            ajax.onreadystatechange = function () {
                if (ajax.readyState == 4 && ajax.status == 200) {
                    //console.log(ajax.responseText);
                    var str = ajax.responseText;
                    //将json字符串转换为json对象
                    var obj = eval("(" + str + ")");
                    var list = obj.data.rows;
                    var item = list[0];
                    _this.QcCashierFruitUrl = item.appUrl;
                }
            };
        },
        getQcCashierUrl(){
            let _this = this
            var ajax = new XMLHttpRequest();
            // 使用get请求
            ajax.open("get", 'https://gateway.htd.cn/prod/htdtcashier/appVersion/getAppVersion?appSource=1003&callback=callbackfunction&channelType=1');
            ajax.setRequestHeader("Content-type", "application/json");
            // 格式type=3&bin=998字符串的格式
            ajax.send();
            // 注册事件
            ajax.onreadystatechange = function () {
                if (ajax.readyState == 4 && ajax.status == 200) {
                    //console.log(ajax.responseText);
                    var str = ajax.responseText;
                    //将json字符串转换为json对象
                    var obj = eval("(" + str + ")");
                    var list = obj.data.rows;
                    var item = list[0];
                    _this.QcCashierUrl = item.appUrl;
                }
            };
        },
        getQcShoppingMallUrl(){
            let _this = this
            var ajax = new XMLHttpRequest();
            // 使用get请求
            ajax.open("get", 'https://gateway.qcos.cn/prod/htdtapp/notAuth/bossappVersion/getBossAppVersion?appSource=1005&callback=callbackfunction&channelType=1');
            ajax.setRequestHeader("Content-type", "application/json");
            // 格式type=3&bin=998字符串的格式
            ajax.send();
            // 注册事件
            ajax.onreadystatechange = function () {
                if (ajax.readyState == 4 && ajax.status == 200) {
                    //console.log(ajax.responseText);
                    var str = ajax.responseText;
                    //将json字符串转换为json对象
                    var obj = eval("(" + str + ")");
                    _this.QcShoppingMallUrl = obj.data.appUrl;
                }
            };
        },
        goApple(url) {
            console.log(url,'1234')
            // window.location.href = url;
            window.open(url);
        },
      linkTo(path) {
          this.$router.push({ path: '/m/' + path })
          this.$nextTick(() => {
              this.open = false
          })
      },
      addTimeStamps(url) {
            // console.log(this.QcShopkeeperUrl,'QcShopkeeperUrl')
            // let url  = this.QcShopkeeperUrl;
            var timestamp = Date.parse(new Date());
            if (url.indexOf("?") != -1) { // 包含？
                url = url + "&timestamp=" + timestamp;
            } else {
                url = url + "?timestamp=" + timestamp;
            }
            // window.open(url, '_blank');
            location.href = url;
        },
      checkBg(item) {
        this.tooItem = item;
      },
      openModal: function() {
        this.tryVisible = true
      },
      modalClose: function(data) {
        this.tryVisible = data
      }
    }
  }
  </script>

  <style lang="less" scoped>
  .mark{
    position:fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.5);
    z-index: 1000;
    .mark_box{
        width: 250px;
        height: 350px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        background: #FFFFFF;
        .seek_close{
        position: absolute;
        right: 15px;
        top: 15px;
        width: 15px;
        height:15px;
        cursor: pointer;
    }
        .mark_title{
            height: 50px;
            font-size: 18px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 50px;
        }
        .mark_code{
            width:250px;
            height:250px;
            display: flex;
            justify-content: center;
            align-items: center;
            .mark_code1{
                width:200px;
                height:200px;
            }
            .mark_code2{
                height:200px;
            }
        }
    }
  }
  .content{
    width:100%;
    padding:15px 15px 0 15px;
    display: flex;
    flex-direction: column;
    background: #f0f2f5;
    .content_box{
        width: 345px;
        min-height: 300px;
        background: #FFFFFF;
        border-radius: 6px;
        display: flex;
        flex-direction: column;
        margin-bottom:10px;
        .box_top{
            width:345px;
            height:108px;
            img{
                width: 100%;
                height:100%;
            }
        }
        .box_bottom{
            flex:1;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-evenly;
            .box_item{
                width: 153px;
                height: 168px;
                background: #FFFFFF;
                border: 1px solid #EAEAEA;
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-top: 15px;
                .item_img{
                    width: 57px;
                    height: 57px;
                    margin-top:24px;
                }
                .item_title{
                    height: 16px;
                    font-size: 11px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    color: #333333;
                    line-height: 16px;
                    margin-top: 6px;
                }
                .box_btn{
                    margin-top: 27px;
                    height:19px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-evenly;
                    width:100%;
                    .item_btn1{
                        background: #67B444;
                    }
                    .item_btn2{
                        background: #1584F7;
                    }
                    .item_btn3{
                        background: #40B4CB;
                    }
                    .item_btn{
                        width: 62px;
                        height: 18px;
                        border-radius: 9px;
                    }
                    img{
                        width: 9px;
                        height: 9px;
                    }
                    span{
                        height: 19px;
                        font-size: 7px;
                        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
                        font-weight: normal;
                        color: #FFFFFF;
                        line-height: 19px;
                    }
                }
                .box_btn3 {
                    margin-top: 10px;
                    flex-direction: column;
                    justify-content: space-between;
                    height: 50px;
                    .item_btn2 {
                        margin-bottom: 6px;
                    }
                }
            }
            .box_item3 {
                width: 100px;
            }
        }
    }
  }

  .banner_box{
    position: absolute;
    top: 68px;
    left:15px;
    .banner_title{
        height: 28px;
        font-size: 20px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 28px;
        text-align: left;
    }
    .banner_title2{
        width: 142px;
        height: 28px;
        font-size: 14px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 14px;
        margin-top: 12px;
        text-align: left
    }
    .banner_line{
        width: 50px;
        height: 3px;
        background: #28DAFB;
        margin-top:6px;

    }
    .banner_text{
        margin-top:22px;
        width: 134px;
        height: 78px;
        font-size: 10px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 17px;
        text-align: left
    }
  }
  .banner {
    width: 100%;
    height: 200px;
    margin-top: 50px;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  </style>
